const safeJsonParse = (value?: string | null) => {
  if (!value?.trim()) return null;

  try {
    return JSON.parse(value?.trim());
  } catch {
    return null;
  }
};

// For RHF `validate`: returns true or an error message
const validateJson = (value?: string | null) => {
  if (!value?.trim()) return true;
  try {
    JSON.parse(value);
    return true;
  } catch (e) {
    return e instanceof Error ? `Invalid JSON: ${e.message}` : "Invalid JSON";
  }
};

// For loading an object into the editor
const prettyStringify = (value: unknown) =>
  value == null ? "" : JSON.stringify(value, null, 2);

export const jsonUtility = { safeJsonParse, validateJson, prettyStringify };
